module.exports = __webpack_public_path__ + "static/media/Sound.d609ced6.mp3";